



import React, { useRef, useState, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
// import SelectStudentModal from "../AdminAttendanceEntry/SelectStudentModal";
import { ApiUrl } from "../../../ApiUrl";
import Select from "react-select";
import { useNavigate } from "react-router-dom";
import "./AdmLessonPlan.css";

const AdmAttendanceEntry = ({
  closePath = "/admin/dashboard",
  listPath = "/admin/lesson-plan",
}) => {
  const navigate = useNavigate();
  const [classOptions, setClassOptions] = useState([]);
  const [sectionOptions, setSectionOptions] = useState([]);
  const [selectedClass, setSelectedClass] = useState(null);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const [mentors, setMentors] = useState([]);
  const [sessionsList, setSessionsList] = useState([]);

  const [subjectOptions, setSubjectOptions] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  const [topicOptions, setTopicOptions] = useState([]);

  const [rows, setRows] = useState([
    { lectureNo: "", moduleNo: "", topic: "", proposedDate: "" },
  ]);

  // State for filters

  const dateFromRef = useRef(null);
  const dateToRef = useRef(null);
  const messageTypeRef = useRef(null);
  const studentNameRef = useRef(null);
  const initiatedByRef = useRef(null);
  const sectionRef = useRef(null);
  const classRef = useRef(null);

  const handleClear = () => {
    if (dateFromRef.current) dateFromRef.current.value = "";
    if (dateToRef.current) dateToRef.current.value = "";
    if (messageTypeRef.current) messageTypeRef.current.value = "";
    if (studentNameRef.current) studentNameRef.current.value = "";
    if (initiatedByRef.current) initiatedByRef.current.value = "";
    if (sectionRef.current) sectionRef.current.value = "";
    if (classRef.current) classRef.current.value = "";

    // Reset state values if using controlled components
    setSelectedClass(null);
    setSelectedSection(null);
    setSelectedSubject(null);
    setSelectedMentor(null);
    setRows([{ lectureNo: "", moduleNo: "", topic: "", proposedDate: "" }]);
  };

  const handleAddRow = () => {
    setRows([
      ...rows,
      { lectureNo: "", moduleNo: "", topic: "", proposedDate: "" },
    ]);
  };

  const handleChange = (index, field, value) => {
    const updatedRows = [...rows];
    updatedRows[index][field] = value;
    setRows(updatedRows);
  };
  useEffect(() => {
    const fetchSectionData = async () => {
      if (!selectedClass) {
        setSectionOptions([]); // Clear sections if no class is selected
        return;
      }

      console.log("Fetching sections for classId:", selectedClass.value); // Debugging

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}ClassSectionBind/GetAllSectionBindWithClass/${selectedClass.value}`
        );
        const data = await response.json();

        console.log("Section API response:", data); // Debugging

        if (data.message === "success") {
          const formattedSections = data.data.map((sectionItem) => ({
            value: sectionItem.section_id,
            label: sectionItem.sectionname,
          }));
          setSectionOptions(formattedSections);
        } else {
          console.error("Failed to fetch sections: ", data.message);
          setSectionOptions([]);
        }
      } catch (error) {
        console.error("Error fetching section data:", error);
        setSectionOptions([]);
      }
    };

    fetchSectionData();
  }, [selectedClass]);

  // Fetch all classes
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}Class/GetAllClass/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          const options = data.data.map((cls) => ({
            value: cls.id,
            label: cls.classname,
          }));
          setClassOptions([{ value: "", label: "Select Class" }, ...options]);
        }
      })
      .catch((error) => {
        console.error("Error fetching class data:", error);
      });
  }, []);

  // Fetch all academic sessions
  useEffect(() => {
    fetch(`${ApiUrl.apiurl}AcademicYear/GetAllAcademicYear/`)
      .then((response) => response.json())
      .then((data) => {
        if (data && data.data) {
          setSessionsList(data.data);
        }
      })
      .catch((error) => {
        console.error("Error fetching session data:", error);
      });
  }, []);

  useEffect(() => {
    const fetchMentors = async () => {
      try {
        const orgId = localStorage.getItem("orgId");
        const branchId = localStorage.getItem("branchId");

        if (!orgId || !branchId) {
          console.error("Missing orgId or branchId in localStorage");
          return;
        }

        const response = await fetch(
          `${ApiUrl.apiurl}Teacher/GetEmployeeList/?orgId=${orgId}&branchId=${branchId}`
        );
        const data = await response.json();
        if (data && data.data) {
          // Mapping data to match React Select options format
          const formattedMentors = data.data.map((mentor) => ({
            value: mentor.id,
            label: mentor.employeeName,
          }));
          setMentors(formattedMentors);
        }
      } catch (error) {
        console.error("Error fetching mentors:", error);
      }
    };

    fetchMentors();
  }, []);

  useEffect(() => {
    const fetchSubjects = async () => {
      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const academicSessionId = localStorage.getItem("academicSessionId");
      if (!selectedClass) {
        setSubjectOptions([]);
        return;
      }

      const classId = selectedClass.value;
      const mapSubjectOptions = (subjectData) =>
        Array.isArray(subjectData)
          ? subjectData.map((subject) => ({
              value: subject.id,
              label: subject.subjectcode,
            }))
          : [];

      const fetchSubjectList = async (searchParams) => {
        const response = await fetch(
          `${ApiUrl.apiurl}SUBJECTS/GetSubjectListBasedOnClassAndSection/?${searchParams}`
        );

        if (response.status === 204) {
          return [];
        }

        const data = await response.json();
        if (data.message === "success" && data.data) {
          return mapSubjectOptions(data.data);
        }

        return [];
      };

      try {
        const baseParams = new URLSearchParams({
          academic_year_id: academicSessionId,
          org_id: orgId,
          branch_id: branchId,
          class_id: classId,
        });
        let options = [];

        if (selectedSection) {
          const sectionParams = new URLSearchParams(baseParams);
          sectionParams.append("section_id", selectedSection.value);
          options = await fetchSubjectList(sectionParams.toString());
        }

        if (!options.length) {
          options = await fetchSubjectList(baseParams.toString());
        }

        setSubjectOptions([{ value: "", label: "Select Subject" }, ...options]);
      } catch (error) {
        console.error("Error fetching subject data:", error);
        setSubjectOptions([{ value: "", label: "Select Subject" }]);
      }
    };

    fetchSubjects();
  }, [selectedClass, selectedSection]);

  // Fetch topics when a subject is selected
  useEffect(() => {
    const fetchTopics = async () => {
      if (!selectedSubject) {
        setTopicOptions([]);
        return;
      }

      const orgId = localStorage.getItem("orgId");
      const branchId = localStorage.getItem("branchId");
      const academicYearId = localStorage.getItem("academicSessionId");
      const subjectId = selectedSubject.value;

      try {
        const response = await fetch(
          `${ApiUrl.apiurl}LESSION_PLAN/GetlessionList/?academic_year_id=${academicYearId}&org_id=${orgId}&branch_id=${branchId}&subject_id=${subjectId}`
        );
        const data = await response.json();

        if (data.message === "success" && data.data) {
          const options = data.data.map((topic) => ({
            value: topic.topicId,
            label: topic.topic_name,
          }));
          setTopicOptions([{ value: "", label: "Select Topic" }, ...options]);
        } else {
          setTopicOptions([{ value: "", label: "Select Topic" }]);
        }
      } catch (error) {
        console.error("Error fetching topic data:", error);
        setTopicOptions([{ value: "", label: "Select Topic" }]);
      }
    };

    fetchTopics();
  }, [selectedSubject]);

const handleSave = async () => {
  const orgId = localStorage.getItem("orgId");
  const branchId = localStorage.getItem("branchId");
  const academicSessionId = localStorage.getItem("academicSessionId");
  const userId = sessionStorage.getItem("userId");

  // Previous session validation check
  if (academicSessionId && sessionsList.length > 0) {
    const selectedSessionObj = sessionsList.find(
      (s) => String(s.id) === String(academicSessionId),
    );

    if (selectedSessionObj) {
      const sessionEndDate = new Date(
        selectedSessionObj.date_to ||
          selectedSessionObj.dateTo ||
          selectedSessionObj.end_date,
      );
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      if (!isNaN(sessionEndDate) && sessionEndDate < today) {
        const sessionLabel =
          selectedSessionObj.sessionname ||
          selectedSessionObj.session_name ||
          selectedSessionObj.label ||
          "the selected session";
        alert(
          `Lesson plans cannot be created for a previous academic session (${sessionLabel}). Please switch to the current academic session.`,
        );
        return;
      }
    } else {
      console.warn(
        "Selected academic session not found in sessionsList — skipping previous-session check.",
        academicSessionId,
        sessionsList,
      );
    }
  }

  if (!selectedClass || !selectedSubject || !selectedMentor) {
    alert("Please select all required fields.");
    return;
  }

  // Filter only rows with required fields
  const validRows = rows.filter(
    (row) => row.lectureNo && row.moduleNo && row.proposedDate,
  );

  if (validRows.length === 0) {
    alert("Please enter at least one complete row.");
    return;
  }

  // Build lesson details: prefer sending topic_id when the entered topic matches an existing topic option.
  const lession_details = validRows.map((row) => {
    const entered = (row.topic || "").toString().trim();
    const match = topicOptions.find(
      (t) =>
        t &&
        t.label &&
        entered &&
        t.label.toString().toLowerCase() === entered.toLowerCase(),
    );

    if (match && match.value) {
      return {
        lectureno: row.lectureNo,
        moduleno: row.moduleNo,
        topic_id: match.value,
        propose_date: row.proposedDate,
      };
    }

    return {
      lectureno: row.lectureNo,
      moduleno: row.moduleNo,
      topic: entered || null,
      propose_date: row.proposedDate,
    };
  });

  const payload = {
    academic_year_id: academicSessionId,
    org_id: orgId,
    branch_id: branchId,
    class_id: selectedClass.value,
    section_id: selectedSection ? selectedSection.value : null,
    subject_id: selectedSubject.value,
    teacher_id: selectedMentor.value,
    lession_details,
    created_by: userId,
  };

  try {
    const response = await fetch(
      `${ApiUrl.apiurl}LESSION_PLAN/lessonPlanCreate/`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(payload),
      },
    );

    const result = await response.json();
    if (result.message === "success") {
      alert("Lesson Plan Created Successfully!");

      window.dispatchEvent(new Event("lesson-plan-created"));

      setSelectedClass(null);
      setSelectedSection(null);
      setSelectedSubject(null);
      setSelectedMentor(null);
      setRows([{ lectureNo: "", moduleNo: "", topic: "", proposedDate: "" }]);
      navigate(listPath);
    } else {
      alert("Failed to create lesson plan.");
    }
  } catch (error) {
    console.error("Error saving lesson plan:", error);
    alert("Error saving lesson plan.");
  }
};

  return (
    <div className="container-fluid">
      <div className="row">
        <div className="col-12">
          <div className="card p-0">
            <div className="card-body">
              <p
                style={{
                  marginBottom: "10px",
                  textAlign: "center",
                  fontSize: "20px",
                  fontWeight: "700",
                }}
              >
                LESSON PLAN 
              </p>
              <div className="row mb-3 mt-3 mx-0">
                <div className="col-12 d-flex flex-wrap gap-2">
                  {/* <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                  >
                    Display
                  </button> */}
                  <button
                    type="button"
                    className="btn btn-primary me-2"
                    style={{ width: "150px" }}
                    onClick={handleSave}
                  >
                    Save
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary me-2"
                    style={{ width: "150px" }}
                    onClick={handleClear}
                  >
                    Clear
                  </button>
                  <button
                    type="button"
                    className="btn btn-danger me-2"
                    style={{ width: "150px" }}
                    onClick={() => navigate(closePath)}
                  >
                    Close
                  </button>
                </div>
              </div>
              <div className="row mt-3 mx-2">
                <div className="col-12 custom-section-box">
                  <div className="d-flex flex-column flex-md-row align-items-start align-items-md-center">
                    <div className="row flex-grow-1">
                      <div className="col-12 col-md-3 mb-1">
                        <label htmlFor="pick-up-point" className="form-label">
                          Teacher
                        </label>
                        <Select
                          id="mentor"
                          options={mentors}
                          className="detail"
                          value={selectedMentor}
                          onChange={setSelectedMentor}
                          placeholder="Select Mentor"
                          classNamePrefix="mentor-dropdown"
                        />
                      </div>
                      <div className="col-md-3">
                        <label htmlFor="class" className="form-label">
                          Class
                        </label>

                        <Select
                          options={classOptions}
                          className="detail"
                          classNamePrefix="class-dropdown"
                          placeholder="Select Class"
                          value={selectedClass}
                          onChange={(option) => {
                            setSelectedClass(option);
                            setSelectedSection(null);
                            setSelectedSubject(null);
                            setSubjectOptions([]);
                          }}
                        />
                      </div>

                      <div className="col-md-3">
                        <label htmlFor="section" className="form-label">
                          Section
                        </label>
                        <Select
                          options={sectionOptions}
                          classNamePrefix="section-dropdown"
                          className="detail"
                          placeholder="Select Section"
                          isDisabled={!selectedClass}
                          value={selectedSection} // Add this line to maintain state
                          onChange={(option) => {
                            setSelectedSection(option);
                            setSelectedSubject(null);
                          }}
                        />
                      </div>

                      <div className="col-12 col-md-3 mb-3">
                        <label htmlFor="subject" className="form-label">
                          Subject
                        </label>
                        <Select
                          options={subjectOptions}
                          className="detail"
                          classNamePrefix="subject-dropdown"
                          placeholder="Select Subject"
                          isDisabled={!selectedClass} // Disable if no class is selected
                          value={selectedSubject}
                          onChange={setSelectedSubject}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-12">
                <div className="table-responsive">
                  <table className="table table-bordered">
                    <thead>
                      <tr>
                        <th>Lecture No</th>
                        <th>Module No</th>
                        <th>Topic</th>
                        <th>Proposed Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {rows.map((row, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              type="text"
                              className="form-control detail"
                              value={row.lectureNo}
                              onChange={(e) =>
                                handleChange(index, "lectureNo", e.target.value)
                              }
                            />
                          </td>
                          <td>
                            <input
                              type="text"
                              className="form-control detail"
                              value={row.moduleNo}
                              onChange={(e) =>
                                handleChange(index, "moduleNo", e.target.value)
                              }
                            />
                          </td>
                          {/* <td>
                            <select
                              className="detail"
                              value={row.topic}
                              onChange={(e) =>
                                handleChange(index, "topic", e.target.value)
                              }
                              disabled={!selectedSubject}
                            >
                              {topicOptions.map((topic, i) => (
                                <option key={i} value={topic.value}>
                                  {topic.label}
                                </option>
                              ))}
                            </select>
                          </td> */}

                          <td>
                            <input
                              type="text"
                              className="form-control detail"
                              placeholder="Enter Topic"
                              value={row.topic}
                              onChange={(e) =>
                                handleChange(index, "topic", e.target.value)
                              }
                            />
                          </td>

                          <td>
                            <input
                              type="date"
                              className="form-control detail"
                              value={row.proposedDate}
                              onChange={(e) =>
                                handleChange(
                                  index,
                                  "proposedDate",
                                  e.target.value
                                )
                              }
                            />
                          </td>
                          <td>
                            {index === rows.length - 1 && (
                              <button
                                className="btn btn-primary"
                                onClick={handleAddRow}
                              >
                                Add
                              </button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdmAttendanceEntry;
